import script from "./DashboardSidebarMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSidebarMobile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__